import { withIndefiniteArticle } from "./indefiniteArticle"
import { joinList } from "./tagsIndexCopy"

// Per-site words for the scene and performer pages' SEO copy: what kind of
// scenes the site shoots (`niche`, lowercase unless it's a proper term) and
// how it describes its video quality, plus an optional `tone`, one adjective
// for the site's style that tag pair intros put before the tags. Keyed by the host the page is served
// as, like `utils/sitePageSeo.js`: an alias's own host when one is in play. A
// site with no entry keeps the generic copy its page builds.
export const SITE_COPY = {
  "anal4k.com": { niche: "anal", quality: "HD 4K" },
  "bbcpie.com": { niche: "interracial creampie", quality: "4K" },
  "castingcouch-x.com": { niche: "amateur casting", quality: "HD" },
  "cum4k.com": { niche: "creampie", quality: "Ultra HD 4K" },
  "exotic4k.com": { niche: "exotic model", quality: "Ultra HD 4K" },
  "facials4k.com": { niche: "facial cumshot", quality: "Ultra HD 4K" },
  "girlcum.com": { niche: "female orgasm", quality: "4K" },
  "holed.com": { niche: "anal", quality: "Full HD and 4K" },
  "lubed.com": { niche: "oiled", quality: "Full HD and 4K" },
  "passion-hd.com": {
    niche: "sensual hardcore",
    quality: "Full HD 1080p",
    tone: "sensual",
  },
  "pornplus.com": { niche: "hardcore", quality: "4K" },
  "pornpros.com": { niche: "hardcore", quality: "Full HD" },
  "puremature.com": { niche: "MILF", quality: "Full HD" },
  "spyfam.com": { niche: "step family", quality: "4K" },
  "strippers4k.com": { niche: "stripper", quality: "Ultra HD 4K" },
  "tiny4k.com": { niche: "petite", quality: "Ultra HD 4K" },
  "wetvr.com": { niche: "virtual reality", quality: "4K VR" },
}

// The copy for `host`, or null. Ignores case and a leading "www.".
export const siteCopy = (host) =>
  SITE_COPY[
    String(host ?? "")
      .toLowerCase()
      .replace(/^www\./, "")
  ] ?? null

// The copy for the site a page is served as: its alias when it has one, the
// same site useSiteSeo names in the page's SEO tags.
export const siteCopyFor = (site) => siteCopy((site?.alias ?? site)?.host)

// The scene page's meta description: "Watch Jane Doe in Title, a petite scene
// from Tiny4K. 31 minutes in Ultra HD 4K, released March 3, 2026. Stream it or
// download it in every format." The cast, runtime and date drop out when
// missing; without a runtime the sentence opens "In Ultra HD 4K".
export const sceneDescription = ({
  copy,
  siteName,
  title,
  actorNames = [],
  releaseDate = "",
  durationMinutes = null,
}) => {
  const subject = actorNames.length
    ? `Watch ${joinList(actorNames)} in ${title}`
    : `Watch ${title}`
  const runtime = durationMinutes
    ? `${durationMinutes} ${durationMinutes === 1 ? "minute" : "minutes"} in`
    : "In"
  const released = releaseDate ? `, released ${releaseDate}` : ""

  return [
    `${subject}, ${withIndefiniteArticle(copy.niche)} scene from ${siteName}.`,
    `${runtime} ${copy.quality}${released}.`,
    "Stream it or download it in every format.",
  ].join(" ")
}

const sceneCountLabel = (count) =>
  `${count.toLocaleString("en-US")} ${count === 1 ? "Scene" : "Scenes"}`

// The performer page's title: "Jane Doe - Tiny4K Porn Videos (12 Scenes)",
// without the count when the performer has no scenes on the site.
export const modelTitle = ({ siteName, name, sceneCount = 0 }) =>
  `${name} - ${siteName} Porn Videos${sceneCount > 0 ? ` (${sceneCountLabel(sceneCount)})` : ""}`

// "her" or "his" from the performer's gender ("girl" or "guy" in the
// database), or null when it's anything else.
export const possessivePronoun = (gender) => {
  const value = String(gender ?? "").toLowerCase()
  if (["girl", "female", "woman"].includes(value)) return "her"
  if (["guy", "male", "man"].includes(value)) return "his"
  return null
}

// The performer page's meta description: "Jane Doe stars in 12 petite scenes
// on Tiny4K. Watch her full-length Ultra HD 4K videos, see her photos, and
// browse similar Tiny4K models." The page has no bio, so the copy doesn't
// promise one.
export const modelDescription = ({
  copy,
  siteName,
  name,
  sceneCount = 0,
  gender,
}) => {
  const scenes =
    sceneCount > 0
      ? `${sceneCount.toLocaleString("en-US")} ${copy.niche} ${sceneCount === 1 ? "scene" : "scenes"}`
      : `${copy.niche} scenes`
  const pronoun = possessivePronoun(gender)
  const watch = pronoun
    ? `Watch ${pronoun} full-length ${copy.quality} videos, see ${pronoun} photos,`
    : `Watch full-length ${copy.quality} videos and photos,`

  return `${name} stars in ${scenes} on ${siteName}. ${watch} and browse similar ${siteName} models.`
}
